export const CheckCircle = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.2369 6.53939C13.6402 6.15354 14.2941 6.15354 14.6975 6.53939C15.1008 6.92529 15.1008 7.55094 14.6975 7.93684L9.00905 13.4606C8.80735 13.6535 8.54303 13.75 8.27871 13.75C8.01439 13.75 7.75002 13.6535 7.54837 13.4606L5.30251 11.3124C4.89916 10.9265 4.89916 10.3009 5.30251 9.91496C5.70581 9.52906 6.35979 9.52906 6.76309 9.91496L8.27861 11.3644L13.2369 6.53939Z"
			fill="#24C875"
		/>
	</svg>
);
